<template>
<div>
    <v-textarea
        :label="label"
        :value="value"
        :readonly="readonly"
        :prepend-icon="prependIcon"
        :hint="hint"
        :persistent-hint="persistentHint"
        v-on:input="onTextFieldInput"
        rows="1"
        auto-grow
        :rules="rules"
        :autofocus="autofocus"
    >
        <span 
            slot="append-outer"
            v-if="menu_items.length == 1"
        >

            <v-icon
                v-on:click="onClickMenuItem(menu_items[0])"
            >
                {{menu_items[0].icon}}
            </v-icon>

        </span>

        <span 
            slot="append-outer"
            v-if="menu_items.length > 1"
        >

            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-for="(item, index) in menu_items"
                    :key="'menu_item_'+index"
                    v-on:click="onClickMenuItem(item)"
                >
                    <v-list-item-icon
                        v-if="item.icon != null"
                    >
                        <v-icon>{{item.icon}}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>{{item.text}}</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 

        </span>

    </v-textarea>
</div>
</template>

<script>
export default {
    props: {
        
        value: {
            type: [String, Number],
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return null; }
        },

        readonly: {
            type: Boolean,
            default: function() { return false; }
        },

        prependIcon: {
            type: String,
            default: function() { return null; }
        },

        hint: {
            type: String,
            default: function() { return null; }
        },

        persistentHint: {
            type: String,
            default: function() { return null; }
        },

        emoji: {
            type: Boolean,
            default: function() { return false; }
        },

        search: {
            type: Boolean,
            default: function() { return false; }
        },

        rules: {
            type: Array,
            default: function () { return []; }
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; }
        },
    },


    methods: {
        onClickMenuItem(menu_item) {

            if ( this.hasListener(menu_item.event) )
            {
                this.$emit(menu_item.event);
                return;
            }

            // Has default action...?
            if ( menu_item.event == 'pick-emoji' )
            {
                this.pickEmoji();
            }
        },

        pickEmoji()
        {
            this.$rc.simplePickEmoji(
                (append_emoji) => {

                    if ( append_emoji == null ) 
                        return;

                    if ( this.value == null || this.value.trim().length == 0 ) 
                    { 
                        this.$emit('input', append_emoji);
                        return;
                    }

                    let new_value = this.value+' '+append_emoji;
                    this.$emit('input', new_value);
                }
            );
        },

        hasListener(event) {
            return this.$listeners && this.$listeners[event];
        },

        onTextFieldInput(value)
        {
            this.$emit('input', value);
        },
    },

    computed: {

        menu_items() {
            let ret = [];

            if ( this.emoji )
            {
                ret.push({
                    'text': 'Emoji Picker...',
                    'event': 'pick-emoji',
                    'icon': 'mdi-emoticon-outline',
                    'enabled': true,
                });
            }

            if ( this.search )
            {
                ret.push({
                    'text': 'Search...',
                    'event': 'search',
                    'icon': 'mdi-magnify',
                    'enabled': true,
                });
            }

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>